import React from 'react';
import { CandleLandingPage } from './pages/CandleLandingPage';
export function App() {
  return <CandleLandingPage data-id="element-0" />;
}